/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Translation_Please_WaitInputs */



/**
* | output |
* | --- |
* | "Loading translation... please wait..." |
*
* @param {Loading_Translation_Please_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const loading_translation_please_wait = /** @type {((inputs?: Loading_Translation_Please_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Translation_Please_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement de la traduction... veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzung wird geladen... Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento traduzione... attendere prego...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка перевода... пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando traducción... por favor espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载翻译……请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳を読み込んでいます...お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद लोड हो रहा है... कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando tradução... aguarde...")
	return /** @type {LocalizedString} */ ("Loading translation... please wait...")
});